<template>
	<div class="main-scroll-area">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'App',
	data: function () {
		return {
			layout: null,
			headerIsShow: true
		}
	},
	beforeCreate: function () {
		this.layout = this.$route.meta.layout
	},
	created () {
		const meta = this.$route.meta
		if (meta.hasOwnProperty('title')) {
			this.setTitle(meta.title)
		}
	},
	methods: {
		setTitle (text) {
			document.title = text + ' | Контрольная панель'
		}
	},
	watch: {
		'$route' (to, from) {
			this.setTitle(to.meta.title)
		}
	}
}
</script>
<style lang="scss">
	// CoreUI Icons Set
  @import '@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import 'font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import 'flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
	.main-scroll-area { min-height: 100vh; }
</style>



// WEBPACK FOOTER //
// src/App.vue